import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { Router, provideRouter, withInMemoryScrolling } from '@angular/router';
import { API_CLIENT_CONFIG, AUTH_STRATEGY, ExternalAuthService, InternalAuthService } from '@xbh/common-lib';
import { providePrimeNG } from 'primeng/config';
import { catchError, concatMap, of } from 'rxjs';
import { environment } from '../environments/environment';
import { DataCacheService } from './../app/shared/data-save/data-cache.service';
import { MasterDataStore } from './../app/shared/services/master-data.store';
import { routes } from './app.routes';
import { MP9010_DISPLAY } from './pages/common/constants/mp9010-display.constants';
import { navigateToErrorPage } from './pages/common/utils/navigate-to';
import { DynamicAuthStrategyService } from './shared/services/dynamic-auth-strategy.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
    ),
    providePrimeNG({
      unstyled: true, // デザインを完全に奪う
      theme: {
        options: {
          // CSSの優先順位を制御（Tailwindのユーティリティクラスを最強にする）
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
    {
      provide: API_CLIENT_CONFIG,
      // environment オブジェクトを型を合わせてそのまま注入する
      useValue: environment,
    },
    {
      provide: AUTH_STRATEGY,
      // isInternal の値に応じて、登録した実体サービスを切り替えて割り当てます
      useClass: DynamicAuthStrategyService,
    },
    // 起動時に社内/社外判定して environment.bffUrl を上書きする（同期処理）
    provideAppInitializer(() => {
      const dynamicAuth = inject(DynamicAuthStrategyService);
      const isInternal = dynamicAuth.isCurrentlyInternal;
      environment.bffUrl = isInternal ? (environment.bffUrlInternal ?? environment.bffUrl) : (environment.bffUrlExternal ?? environment.bffUrl);
      return;
    }),
    InternalAuthService,
    ExternalAuthService,
    provideAppInitializer(() => {
      const cacheService = inject(DataCacheService);
      const masterDataStore = inject(MasterDataStore);
      const router = inject(Router);

      return cacheService.initTempData().pipe(
        concatMap(() =>
          masterDataStore.loadAsObservable().pipe(
            catchError(() => {
              // MP0051 失敗時は MP0001 を呼べないため、ポータル初期取得一式として 1 件だけ登録する
              cacheService.registInitDataUnavailableUsageHistory();
              navigateToErrorPage(null, router, MP9010_DISPLAY.portal);
              return of(null);
            }),
          ),
        ),
      );
    }),
  ],
};
